<footer>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 footer-styles">
    <div class="container-fluid b-top text-center p-3">
      Made with ❤ in India |
      Let's Connect : <span
        ><a target="_blank" href="https://www.linkedin.com/in/saihanuman/">
          Sai Hanuman
          <i class="fa fa-linkedin-square" aria-hidden="true"></i></a
      ></span>
    </div>
  </div>
</footer>
